import { styled } from "@mui/material";
import Grid from '@mui/material/Grid2';

const ToolButtonsContainer = styled(Grid)(({ theme }) => ({
  "& .MuiButtonBase-root": {
    color: theme.palette.common.white,
    margin: theme.spacing(0.75, 1.25),
  },
}));

export default ToolButtonsContainer;
